import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'ppa-pagina-inicial',
  templateUrl: './pagina-inicial.component.html',
  styleUrls: ['./pagina-inicial.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PaginaInicialComponent implements OnInit {
  rotaPadrao = true;
  constructor(private rota: Router) {
    if (this.rota.routerState.snapshot.url.lastIndexOf('home-alternativo') > 0) {
      this.rotaPadrao = false;
    }
  }

  ngOnInit() {
  }

}
